import { CurrentSchoolYear } from 'Src/ng2/shared/constants/current-school-year.constant';
import { TwoYearPrior, OneYearPrior } from './../../../../shared/constants/current-school-year.constant';
import { identity } from 'lodash';

export const ATTENDANCE_PANEL_PROJECTION = [
  'ABSENCES_YTD',
  'PAST_10_ATT',
  'PAST_20_ATT',
  'CONSECUTIVE_ABSENCES',
  'LATENESS_YTD',
  'LATENESS_LAST_10_DAYS',
  'LATENESS_LAST_20_DAYS',
  'CONSECUTIVE_LATENESS',
  'CURR_YTD_ATT',
  'OVERALL_ATTENDANCE_1_YEAR_PRIOR',
  'OVERALL_ATTENDANCE_2_YEAR_PRIOR',
  'SEPT_ATTENDANCE_CURR_SY',
  'OCT_ATTENDANCE_CURR_SY',
  'NOV_ATTENDANCE_CURR_SY',
  'DEC_ATTENDANCE_CURR_SY',
  'JAN_ATTENDANCE_CURR_SY',
  'FEB_ATTENDANCE_CURR_SY',
  'MAR_ATTENDANCE_CURR_SY',
  'APR_ATTENDANCE_CURR_SY',
  'MAY_ATTENDANCE_CURR_SY',
  'JUNE_ATTENDANCE_CURR_SY',
  'SEPT_ATTENDANCE_1_YEAR_PRIOR',
  'OCT_ATTENDANCE_1_YEAR_PRIOR',
  'NOV_ATTENDANCE_1_YEAR_PRIOR',
  'DEC_ATTENDANCE_1_YEAR_PRIOR',
  'JAN_ATTENDANCE_1_YEAR_PRIOR',
  'FEB_ATTENDANCE_1_YEAR_PRIOR',
  'MAR_ATTENDANCE_1_YEAR_PRIOR',
  'APR_ATTENDANCE_1_YEAR_PRIOR',
  'MAY_ATTENDANCE_1_YEAR_PRIOR',
  'JUNE_ATTENDANCE_1_YEAR_PRIOR',
  'SEPT_ATTENDANCE_2_YEAR_PRIOR',
  'OCT_ATTENDANCE_2_YEAR_PRIOR',
  'NOV_ATTENDANCE_2_YEAR_PRIOR',
  'DEC_ATTENDANCE_2_YEAR_PRIOR',
  'JAN_ATTENDANCE_2_YEAR_PRIOR',
  'FEB_ATTENDANCE_2_YEAR_PRIOR',
  'MAR_ATTENDANCE_2_YEAR_PRIOR',
  'APR_ATTENDANCE_2_YEAR_PRIOR',
  'MAY_ATTENDANCE_2_YEAR_PRIOR',
  'JUNE_ATTENDANCE_2_YEAR_PRIOR',
];

export const THIS_YEAR_ATT_TABLE_COLUMNS = {
  STUB: {
    key: 'STUB',
    human: 'This year',
    cellStyles: () => null,
    valueFormatter: identity,
  },
  CURRENT_STREAK: {
    key: 'CURRENT_STREAK',
    human: 'Current Streak',
    cellStyles: () => null,
    valueFormatter: identity,
  },
  PAST_10: {
    key: 'PAST_10',
    human: 'Past 10 Days',
    cellStyles: () => null,
    valueFormatter: identity,
  },
  PAST_20: {
    key: 'PAST_20',
    human: 'Past 20 Days',
    cellStyles: () => null,
    valueFormatter: identity,
  },
  THIS_YEAR: {
    key: 'THIS_YEAR',
    human: 'This Year',
    cellStyles: () => null,
    valueFormatter: identity,
  },
};

export const THIS_YEAR_ABSENT_ROW = [
  { key: 'STUB', path: null, human: 'Days absent' },
  { key: 'CURRENT_STREAK', path: 'CONSECUTIVE_ABSENCES' },
  { key: 'PAST_10', path: 'PAST_10_ATT' },
  { key: 'PAST_20', path: 'PAST_20_ATT' },
  { key: 'THIS_YEAR', path: 'ABSENCES_YTD' },
];

export const THIS_YEAR_LATE_ROW = [
  { key: 'STUB', path: null, human: 'Days late' },
  { key: 'CURRENT_STREAK', path: 'CONSECUTIVE_LATENESS' },
  { key: 'PAST_10', path: 'LATENESS_LAST_10_DAYS' },
  { key: 'PAST_20', path: 'LATENESS_LAST_20_DAYS' },
  { key: 'THIS_YEAR', path: 'LATENESS_YTD' },
];

export const THIS_YEAR_ATT_TABLE_CONFIG = {
  colDefs: THIS_YEAR_ATT_TABLE_COLUMNS,
  rows: [THIS_YEAR_ABSENT_ROW, THIS_YEAR_LATE_ROW],
};

export const THIS_WEEK_ATT_TABLE_COLUMNS = {
  STUB: {
    key: 'STUB',
    human: 'By weekday',
    cellStyles: () => null,
    valueFormatter: identity,
  },
  MONDAY: {
    key: 'MONDAY',
    human: 'Mon',
    cellStyles: () => null,
    valueFormatter: identity,
  },
  TUESDAY: {
    key: 'TUESDAY',
    human: 'Tues',
    cellStyles: () => null,
    valueFormatter: identity,
  },
  WEDNESDAY: {
    key: 'WEDNESDAY',
    human: 'Wed',
    cellStyles: () => null,
    valueFormatter: identity,
  },
  THURSDAY: {
    key: 'THURSDAY',
    human: 'Thurs',
    cellStyles: () => null,
    valueFormatter: identity,
  },
  FRIDAY: {
    key: 'FRIDAY',
    human: 'Fri',
    cellStyles: () => null,
    valueFormatter: identity,
  },
};

export const THIS_WEEK_ABSENT_ROW = [
  { key: 'STUB', path: null, human: 'Days absent' },
  { key: 'MONDAY', path: 'COUNT_OF_ABSENCES_MON' },
  { key: 'TUESDAY', path: 'COUNT_OF_ABSENCES_TUES' },
  { key: 'WEDNESDAY', path: 'COUNT_OF_ABSENCES_WED' },
  { key: 'THURSDAY', path: 'COUNT_OF_ABSENCES_THURS' },
  { key: 'FRIDAY', path: 'COUNT_OF_ABSENCES_FRI' },
];

export const THIS_WEEK_LATE_ROW = [
  { key: 'STUB', path: null, human: 'Days late' },
  { key: 'MONDAY', path: 'COUNT_OF_LATENESSES_MON' },
  { key: 'TUESDAY', path: 'COUNT_OF_LATENESSES_TUES' },
  { key: 'WEDNESDAY', path: 'COUNT_OF_LATENESSES_WED' },
  { key: 'THURSDAY', path: 'COUNT_OF_LATENESSES_THURS' },
  { key: 'FRIDAY', path: 'COUNT_OF_LATENESSES_FRI' },
];

export const THIS_WEEK_ATT_TABLE_CONFIG = {
  colDefs: THIS_WEEK_ATT_TABLE_COLUMNS,
  rows: [THIS_WEEK_ABSENT_ROW, THIS_WEEK_LATE_ROW],
};

export const HISTORIC_ATT_TABLE_COLUMNS = {
  STUB: {
    key: 'STUB',
    human: 'Historical',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  YTD: {
    key: 'YTD',
    human: 'YTD',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  SEPT: {
    key: 'SEPT',
    human: 'Sept',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  OCT: {
    key: 'OCT',
    human: 'Oct',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  NOV: {
    key: 'NOV',
    human: 'Nov',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  DEC: {
    key: 'DEC',
    human: 'Dec',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  JAN: {
    key: 'JAN',
    human: 'Jan',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  FEB: {
    key: 'FEB',
    human: 'Feb',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  MAR: {
    key: 'MAR',
    human: 'Mar',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  APR: {
    key: 'APR',
    human: 'Apr',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  MAY: {
    key: 'MAY',
    human: 'May',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  JUNE: {
    key: 'JUNE',
    human: 'June',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
  OVERALL: {
    key: 'OVERALL',
    human: 'Overall',
    cellStyles: (v: number) => historicColumnStyles(v),
    valueFormatter: historicValueFormatter,
  },
};

export const CURRENT_SY_ROW = [
  { key: 'STUB', path: null, human: `SY${CurrentSchoolYear.START}-${CurrentSchoolYear.END}` },
  { key: 'YTD', path: 'CURR_YTD_ATT' },
  { key: 'SEPT', path: 'SEPT_ATTENDANCE_CURR_SY' },
  { key: 'OCT', path: 'OCT_ATTENDANCE_CURR_SY' },
  { key: 'NOV', path: 'NOV_ATTENDANCE_CURR_SY' },
  { key: 'DEC', path: 'DEC_ATTENDANCE_CURR_SY' },
  { key: 'JAN', path: 'JAN_ATTENDANCE_CURR_SY' },
  { key: 'FEB', path: 'FEB_ATTENDANCE_CURR_SY' },
  { key: 'MAR', path: 'MAR_ATTENDANCE_CURR_SY' },
  { key: 'APR', path: 'APR_ATTENDANCE_CURR_SY' },
  { key: 'MAY', path: 'MAY_ATTENDANCE_CURR_SY' },
  { key: 'JUNE', path: 'JUNE_ATTENDANCE_CURR_SY' },
  { key: 'OVERALL', path: 'OVERALL_ATTENDANCE_CURR_SY' },
];

export const ONE_YEAR_PRIOR_ROW = [
  { key: 'STUB', path: null, human: `SY${OneYearPrior.START}-${OneYearPrior.END}` },
  { key: 'YTD', path: 'OVERALL_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'SEPT', path: 'SEPT_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'OCT', path: 'OCT_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'NOV', path: 'NOV_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'DEC', path: 'DEC_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'JAN', path: 'JAN_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'FEB', path: 'FEB_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'MAR', path: 'MAR_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'APR', path: 'APR_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'MAY', path: 'MAY_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'JUNE', path: 'JUNE_ATTENDANCE_1_YEAR_PRIOR' },
  { key: 'OVERALL', path: 'OVERALL_ATTENDANCE_1_YEAR_PRIOR' },
];

export const TWO_YEAR_PRIOR_ROW = [
  { key: 'STUB', path: null, human: `SY${TwoYearPrior.START}-${TwoYearPrior.END}` },
  { key: 'YTD', path: 'OVERALL_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'SEPT', path: 'SEPT_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'OCT', path: 'OCT_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'NOV', path: 'NOV_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'DEC', path: 'DEC_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'JAN', path: 'JAN_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'FEB', path: 'FEB_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'MAR', path: 'MAR_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'APR', path: 'APR_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'MAY', path: 'MAY_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'JUNE', path: 'JUNE_ATTENDANCE_2_YEAR_PRIOR' },
  { key: 'OVERALL', path: 'OVERALL_ATTENDANCE_2_YEAR_PRIOR' },
];

export const HISTORIC_ATT_TABLE_CONFIG = {
  colDefs: HISTORIC_ATT_TABLE_COLUMNS,
  rows: [CURRENT_SY_ROW, ONE_YEAR_PRIOR_ROW, TWO_YEAR_PRIOR_ROW],
};

function historicColumnStyles(val: number) {
  if (val && val < 80) return { 'background-color': 'var(--color-pink-40)' };
  else if (val && val < 90) return { 'background-color': 'var(--color-pink-30)' };
  return '';
}

function historicValueFormatter(val: number): string {
  return val ? `${val.toFixed(0)}%` : null;
}
